import { render, staticRenderFns } from "./AnimatedBox.vue?vue&type=template&id=989ab7a0&scoped=true"
import script from "./AnimatedBox.vue?vue&type=script&lang=js"
export * from "./AnimatedBox.vue?vue&type=script&lang=js"
import style0 from "./AnimatedBox.vue?vue&type=style&index=0&id=989ab7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989ab7a0",
  null
  
)

export default component.exports